var _rect, _text, _rect2, _text2, _line, _polygon, _rect3, _text3, _line2, _line3, _line4, _line5, _line6, _rect4, _text4, _text5, _text6, _rect5, _text7, _text8, _text9, _rect6, _text10, _text11, _text12, _rect7, _text13, _text14, _text15, _rect8, _text16, _text17, _text18, _line7, _line8, _line9, _line10, _rect9, _text19, _text20, _text21, _text22, _line11, _polygon2, _line12, _polygon3, _line13, _polygon4, _rect10, _text23, _rect11, _text24, _rect12, _text25, _text26, _text27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEvalPipeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 500",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "evBoxGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#111111",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 500,
    rx: 8,
    fill: "#0C0C0C",
    stroke: "#DCCA87",
    strokeOpacity: 0.15,
    strokeWidth: 1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 36,
    textAnchor: "middle",
    fontFamily: "monospace",
    fontSize: 11,
    fill: "#DCCA87",
    letterSpacing: 2,
    opacity: 0.7
  }, "EVALUATION PIPELINE \u2014 MULTI-GATE ARCHITECTURE")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 340,
    y: 56,
    width: 120,
    height: 34,
    rx: 17,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 77,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#DCCA87"
  }, "Trigger")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 90,
    x2: 400,
    y2: 112,
    stroke: "#DCCA87",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "396,112 400,119 404,112",
    fill: "#DCCA87",
    fillOpacity: 0.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 120,
    width: 200,
    height: 40,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.5,
    strokeWidth: 1.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 145,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Orchestrator")), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 330,
    y1: 160,
    x2: 130,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 365,
    y1: 160,
    x2: 280,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 160,
    x2: 430,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 435,
    y1: 160,
    x2: 580,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 470,
    y1: 160,
    x2: 720,
    y2: 196,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 198,
    width: 130,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 220,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Schema Validation")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 238,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "~30s \xB7 deterministic")), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 130,
    y: 252,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "structural reliability")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 198,
    width: 130,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 220,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Golden Dataset")), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 238,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "~3min \xB7 regression")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 280,
    y: 252,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "frozen expected output")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 365,
    y: 198,
    width: 130,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 220,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "LLM-as-Judge")), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 238,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "~5min \xB7 quality")), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    x: 430,
    y: 252,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "calibrated rubrics")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 515,
    y: 198,
    width: 130,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.25,
    strokeWidth: 1
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 220,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#FFFFFF"
  }, "Retrieval Bench")), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 238,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#AAAAAA"
  }, "~2min \xB7 recall/MRR")), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    x: 580,
    y: 252,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "ranking quality")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 665,
    y: 198,
    width: 110,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#666666",
    strokeOpacity: 0.4,
    strokeWidth: 1,
    strokeDasharray: "3,3"
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 220,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 11,
    fill: "#AAAAAA"
  }, "Drift Detection")), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 238,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "nightly \xB7 scheduled")), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    x: 720,
    y: 252,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 9,
    fill: "#666666"
  }, "no deploy trigger")), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 130,
    y1: 258,
    x2: 310,
    y2: 300,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 280,
    y1: 258,
    x2: 350,
    y2: 300,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 430,
    y1: 258,
    x2: 420,
    y2: 300,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 580,
    y1: 258,
    x2: 470,
    y2: 300,
    stroke: "#DCCA87",
    strokeOpacity: 0.3,
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 300,
    width: 200,
    height: 60,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#DCCA87",
    strokeOpacity: 0.6,
    strokeWidth: 1.5
  })), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 324,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: 500
  }, "Gate Decision")), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 348,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#4CAF50"
  }, "PASS")), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 348,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#FFC107"
  }, "REVIEW")), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    x: 460,
    y: 348,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#F44336"
  }, "FAIL")), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 360,
    x2: 290,
    y2: 400,
    stroke: "#4CAF50",
    strokeOpacity: 0.6,
    strokeWidth: 1
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "287,396 290,404 294,397",
    fill: "#4CAF50",
    fillOpacity: 0.6
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 400,
    y1: 360,
    x2: 400,
    y2: 400,
    stroke: "#FFC107",
    strokeOpacity: 0.6,
    strokeWidth: 1
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "396,400 400,407 404,400",
    fill: "#FFC107",
    fillOpacity: 0.6
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 460,
    y1: 360,
    x2: 510,
    y2: 400,
    stroke: "#F44336",
    strokeOpacity: 0.6,
    strokeWidth: 1
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "507,397 510,404 514,396",
    fill: "#F44336",
    fillOpacity: 0.6
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 240,
    y: 408,
    width: 100,
    height: 32,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#4CAF50",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 428,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#4CAF50"
  }, "Canary Deploy")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 350,
    y: 408,
    width: 100,
    height: 32,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#FFC107",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 428,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#FFC107"
  }, "Human Review")), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 460,
    y: 408,
    width: 100,
    height: 32,
    rx: 4,
    fill: "url(#evBoxGrad)",
    stroke: "#F44336",
    strokeOpacity: 0.4,
    strokeWidth: 1
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    x: 510,
    y: 428,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 10,
    fill: "#F44336"
  }, "Block + Alert")), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 460,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#666666"
  }, "10% traffic \xB7 15min bake")), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    x: 290,
    y: 472,
    textAnchor: "middle",
    fontFamily: "sans-serif",
    fontSize: 8,
    fill: "#666666"
  }, "auto-rollback")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvalPipeline);
export default __webpack_public_path__ + "static/media/eval-pipeline.f223ac08cf53fce8afb68a32bb97a5b5.svg";
export { ForwardRef as ReactComponent };